<template>
  <div
    v-if="incident"
    class="incident-banner"
    :class="'incident-banner--' + incident.severity"
  >
    <span class="incident-banner__icon">⚠</span>
    <span class="incident-banner__message">
      <strong>{{ incident.incident_code }}</strong> — {{ incident.title }}
    </span>
    <a
      href="/status"
      target="_blank"
      rel="noopener"
      class="incident-banner__link"
    >
      Ver detalhes
    </a>
    <button class="incident-banner__close" @click="dismiss">✕</button>
  </div>
</template>

<script>
import { BUS_EVENTS } from 'shared/constants/busEvents';

export default {
  name: 'IncidentBanner',

  data() {
    return {
      incident: null,
      dismissed: false,
    };
  },

  mounted() {
    this.$emitter.on(BUS_EVENTS.INCIDENT_ACTIVE, this.onIncidentActive);
    this.$emitter.on(BUS_EVENTS.INCIDENT_RESOLVED, this.onIncidentResolved);
  },

  beforeDestroy() {
    this.$emitter.off(BUS_EVENTS.INCIDENT_ACTIVE, this.onIncidentActive);
    this.$emitter.off(BUS_EVENTS.INCIDENT_RESOLVED, this.onIncidentResolved);
  },

  methods: {
    onIncidentActive(data) {
      if (!['critical', 'high'].includes(data.severity)) return;
      this.incident = data;
      this.dismissed = false;
    },
    onIncidentResolved() {
      this.incident = null;
    },
    dismiss() {
      this.incident = null;
    },
  },
};
</script>

<style scoped>
.incident-banner {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 16px;
  font-size: 0.875rem;
  font-weight: 500;
}

.incident-banner--critical {
  background: #fee2e2;
  color: #991b1b;
}
.incident-banner--high {
  background: #fef9c3;
  color: #854d0e;
}

.incident-banner__message {
  flex: 1;
}

.incident-banner__link {
  text-decoration: underline;
  white-space: nowrap;
}

.incident-banner__close {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 1rem;
  line-height: 1;
  padding: 0;
  opacity: 0.6;
}

.incident-banner__close:hover {
  opacity: 1;
}
</style>
